<div class="container-fluid p-4 overflow-auto" [style]="(`height: calc(100vh - 150px)`)">
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center">
                <h4 class="mb-0 text-secondary">{{ title }}</h4>
                <div class="d-flex align-items-center mt-3 mt-md-0">
                    <dx-select-box
                        class="me-3"
                        [label]="'&nbsp;'"
                        [items]="aggregateOptions"
                        [(value)]="aggregateValue"
                        (onValueChanged)="onAggregateChanged()"
                        valueExpr="value"
                        displayExpr="text"
                        stylingMode="filled">
                    </dx-select-box>
                    <dx-date-range-box
                        [multiView]="false"
                        [showClearButton]="true"
                        [(value)]="dateRangeFilterValue"
                        (onValueChanged)="onDateRangeChanged($event)"
                        stylingMode="filled">
                    </dx-date-range-box>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-4">
        <!-- Chart 1: Amount in LC -->
        <div class="col-12">
            <div class="card border-0 shadow-sm h-100">
                <div class="card-body">
                    <div class="d-sm-flex justify-content-center align-items-center mb-4">
                        <h4 class="mb-0 text-secondary">Amount in LC</h4>
                    </div>
                    <dx-chart [dataSource]="data" [zoomAndPan]="{ argumentAxis: 'pan' }" resolveLabelOverlapping="hide" (onPointClick)="onPointClick($event)">
                        <dxi-series
                            argumentField="date"
                            valueField="amountInLc"
                            type="bar"
                            name="Amount in LC"
                            [color]="amountColor">
                            <dxo-label [visible]="true" [customizeText]="formatLabelText"></dxo-label>
                        </dxi-series>
                        <dxo-argument-axis type="continuous" argumentType="datetime"
                                           [wholeRange]="wholeRange" [visualRange]="visualRange"
                                           [tickInterval]="tickInterval">
                            <dxo-label [visible]="true"></dxo-label>
                            <dxo-grid [visible]="false"></dxo-grid>
                            <dxo-tick [visible]="false"></dxo-tick>
                        </dxo-argument-axis>
                        <dxi-value-axis>
                            <dxo-label format="decimal"></dxo-label>
                            @if (baselineValue !== null) {
                                <dxi-constant-line
                                    [value]="baselineValue!"
                                    [color]="baselineColor"
                                    [width]="2"
                                    dashStyle="dash">
                                    <dxo-label [text]="baselineLabel" [visible]="true"></dxo-label>
                                </dxi-constant-line>
                            }
                        </dxi-value-axis>
                        <dxo-legend [visible]="false"></dxo-legend>
                        <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                    </dx-chart>
                </div>
            </div>
        </div>

        <!-- Chart 2: Quantity -->
        <div class="col-12">
            <div class="card border-0 shadow-sm h-100">
                <div class="card-body">
                    <div class="d-sm-flex justify-content-center align-items-center mb-4">
                        <h4 class="mb-0 text-secondary">Quantity</h4>
                    </div>
                    <dx-chart [dataSource]="data" [zoomAndPan]="{ argumentAxis: 'pan' }" resolveLabelOverlapping="hide" (onPointClick)="onPointClick($event)">
                        <dxo-common-series-settings argumentField="date" type="bar">
                            <dxo-label [visible]="true" [customizeText]="formatLabelText"></dxo-label>
                        </dxo-common-series-settings>
                        <dxi-series valueField="quantityCs" name="CS" [color]="csColor"></dxi-series>
                        <dxi-series valueField="quantityPal" name="PAL" [color]="palColor"></dxi-series>
                        <dxi-series valueField="quantityDsp" name="DSP" [color]="dspColor"></dxi-series>
                        <dxi-series valueField="quantityEa" name="EA" [color]="eaColor"></dxi-series>
                        <dxo-argument-axis type="continuous" argumentType="datetime"
                                           [wholeRange]="wholeRange" [visualRange]="visualRange"
                                           [tickInterval]="tickInterval">
                            <dxo-label [visible]="true"></dxo-label>
                            <dxo-grid [visible]="false"></dxo-grid>
                            <dxo-tick [visible]="false"></dxo-tick>
                        </dxo-argument-axis>
                        <dxi-value-axis>
                            <dxo-label format="decimal"></dxo-label>
                        </dxi-value-axis>
                        <dxo-legend [visible]="true" verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
                        <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                    </dx-chart>
                </div>
            </div>
        </div>
    </div>
</div>
